import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import illustration from '../images/newsletterIllustration.svg'
import NewsletterForm from '../../../components/NewsletterForm'
import WidthContainer from '../../../components/WidthContainer'

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'

const RootContainer = styled(WidthContainer)`
	position: relative;
	margin-bottom: 3rem;
	margin-top: 2rem;
`


const InnerContainer = styled.div`
	display: flex;
	margin: -2rem;
	> * {
		margin: 2rem;
	}
	
	${phoneBreakpoint} {
		flex-direction: column-reverse;
		align-items: center;
	}
`

const Column = styled.div`
	flex: 1;
`

const Illustration = styled.img`
	margin-top: -6rem;
	max-width: 25rem;
	
	${phoneBreakpoint} {
		width: 100%
	}

`
Illustration.defaultProps = {
	alt: '',
	src: illustration,
}

const NewsletterStyled = styled(NewsletterForm)`
	max-width: 30rem;
`


function NewsletterSection({className}) {
	return <RootContainer className={className}>
		<InnerContainer>
			<Column>
				<NewsletterStyled/>
			</Column>
			<Column>
				<Illustration/>
			</Column>
		</InnerContainer>
	</RootContainer>
}

NewsletterSection.propTypes = {
	className: PropTypes.string,
}

NewsletterSection.defaultProps = {
	className: '',
}

export default NewsletterSection
